import queryString from 'query-string';

function useGetQueryString() {
  return queryString.parse(window.location.search);
}

export default useGetQueryString;
